<template>
    <div id="home_forget_div" class="forget">
        <table id="home_forget_table">
            <tbody>
                <tr>
                    <td colspan="2">
                        <div id="home_forget_title">
                            重置密码
                        </div>
                    </td>
                </tr>
                <tr :class="'step1' + (setp == 1 ? '' : 'hide')">
                    <td class="lbl_right"><label for="LOGIN_NAME">用户名:</label></td>
                    <td>
                        <input id="LOGIN_NAME" type="text" class="big_txt1 notnull" placeholder=""
                            v-model="LOGIN_NAME" />
                    </td>
                </tr>
                <tr :class="'step2 ' + (setp == 2 ? '' : 'hide')">
                    <td class="lbl_right"><label for="QUESTION1">问题1:</label></td>
                    <td>
                        <span id="QUESTION1">{{ this.QUESTION1 }}</span>
                    </td>
                </tr>
                <tr :class="'step2 ' + (setp == 2 ? '' : 'hide')">
                    <td class="lbl_right"><label for="ANSWER1">答案1:</label></td>
                    <td>
                        <input id="ANSWER1" type="text" class="big_txt1 notnull" placeholder="" v-model="ANSWER1" />
                    </td>
                </tr>
                <tr :class="'step2 ' + (setp == 2 ? '' : 'hide')">
                    <td class="lbl_right"><label for="QUESTION2">问题2:</label></td>
                    <td>
                        <span id="QUESTION2">{{ this.QUESTION2 }}</span>
                    </td>
                </tr>
                <tr :class="'step2 ' + (setp == 2 ? '' : 'hide')">
                    <td class="lbl_right"><label for="ANSWER2">答案2:</label></td>
                    <td>
                        <input id="ANSWER2" type="text" class="big_txt1 notnull" placeholder="" v-model="ANSWER2" />
                    </td>
                </tr>
                <tr :class="'step2 ' + (setp == 2 ? '' : 'hide')">
                    <td class="lbl_right"><label for="QUESTION3">问题3:</label></td>
                    <td>
                        <span id="QUESTION3">{{ this.QUESTION3 }}</span>
                    </td>
                </tr>
                <tr :class="'step2 ' + (setp == 2 ? '' : 'hide')">
                    <td class="lbl_right"><label for="ANSWER3">答案3:</label></td>
                    <td>
                        <input id="ANSWER3" type="text" class="big_txt1 notnull" placeholder="" v-model="ANSWER3" />
                    </td>
                </tr>
                <tr :class="'step3 ' + (setp == 3 ? '' : 'hide')">
                    <td class="lbl_right"><label for="NEW_LOGIN_PWD_1">新密码:</label></td>
                    <td>
                        <input id="NEW_LOGIN_PWD_1" :type="setp == 3 ? 'password' : 'text'" class="big_txt1 notnull"
                            placeholder="" v-model="NEW_LOGIN_PWD_1" />
                    </td>
                </tr>
                <tr :class="'step3 ' + (setp == 3 ? '' : 'hide')">
                    <td class="lbl_right"><label for="NEW_LOGIN_PWD_2">再次输入密码:</label></td>
                    <td>
                        <input id="NEW_LOGIN_PWD_2" :type="setp == 3 ? 'password' : 'text'" class="big_txt1 notnull"
                            placeholder="" v-model="NEW_LOGIN_PWD_2" />
                    </td>
                </tr>
                <tr>
                    <td class="lbl_right"><label for="checkCode">验证码:</label></td>
                    <td>
                        <div id="left_checkCode">
                            <input id="checkCode" type="text" class="big_txt1 notnull" v-model="YZM" />
                        </div>
                        <div id="left_checkCodeA">
                            <a id="checkCodeA" href="javaScript:void (0);" @click="RefreshYZM"><img id="checkCodeImg"
                                    :src="YZMImg" /></a>
                        </div>
                    </td>
                </tr>
                <tr :class="'step1 ' + (setp == 1 ? '' : 'hide')">
                    <td>&nbsp;</td>
                    <td class="right_btn">
                        <button type="button" class="btn_step" id="btn_next1" @click="Next2">下一步</button>
                    </td>
                </tr>
                <tr :class="'step2 ' + (setp == 2 ? '' : 'hide')">
                    <td>&nbsp;</td>
                    <td class="right_btn">
                        <button type="button" class="btn_step" id="btn_next2" @click="Next3">下一步</button>
                    </td>
                </tr>
                <tr :class="'step3 ' + (setp == 3 ? '' : 'hide')">
                    <td>&nbsp;</td>
                    <td class="right_btn">
                        <button type="button" class="btn_step" id="btn_commit" @click="Submit">确认</button>
                    </td>
                </tr>
                <tr class="tr_tip">
                    <td colspan="2">
                        <div id="div_tip">
                            {{ errmsg }}
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios';
import gConfig from '../gConfig';

export default {
    name: 'forgetPwd',
    data() {
        return {
            setp: 1,
            LOGIN_NAME: "",
            ANSWER1: "",
            ANSWER2: "",
            ANSWER3: "",
            QUESTION1: "",
            QUESTION2: "",
            QUESTION3: "",
            NEW_LOGIN_PWD_1: "",
            NEW_LOGIN_PWD_2: "",
            YZM: "",
            YZMImg: gConfig.web_pc + "/home/IndexMain/GetCheckCode",
            errmsg: ""
        }
    },
    methods: {
        RefreshYZM() {
            var src1 = gConfig.web_pc + "/home/IndexMain/GetCheckCode?t=" + new Date().getMilliseconds();
            this.YZMImg = src1;
        },
        CheckYZM() {
            this.errmsg = "";
            if (this.YZM == undefined || this.YZM == null || this.YZM == "") {
                this.errmsg = "请输入验证码";
                return false;
            } else if (this.YZM.length != 4) {
                this.errmsg = "验证码不正确";
                return false;
            }
            return true;
        },
        Next2() {
            if (!this.CheckYZM()) {
                return;
            }
            const self = this;
            var params = new URLSearchParams();
            params.append('LOGIN_NAME', self.LOGIN_NAME);
            params.append('CHECK_CODE', self.YZM);
            axios.post(gConfig.web_pc + '/home/IndexMain/GetRetrievePwdQuestion', params).then(function (response) {
                self.RefreshYZM();
                var data = response.data;
                var flag = data.flag;
                var msg = data.msg;
                if (flag) {
                    self.QUESTION1 = data.QUESTION1;
                    self.QUESTION2 = data.QUESTION2;
                    self.QUESTION3 = data.QUESTION3;
                    self.setp = 2;
                    self.errmsg = "";
                    self.YZM = "";
                } else {
                    self.errmsg = msg;
                }
            }).catch(function (error) {
                self.RefreshYZM();
                console.log(error);
            });
        },
        Next3() {
            if (!this.CheckYZM()) {
                return;
            }
            const self = this;
            var params = new URLSearchParams();
            params.append('LOGIN_NAME', self.LOGIN_NAME);
            params.append('CHECK_CODE', self.YZM);
            params.append('ANSWER1', self.ANSWER1);
            params.append('ANSWER2', self.ANSWER2);
            params.append('ANSWER3', self.ANSWER3);
            axios.post(gConfig.web_pc + '/home/IndexMain/CheckRetrievePwdAnswer', params).
                then(function (response) {
                    self.RefreshYZM();
                    var data = response.data;
                    var flag = data.flag;
                    var msg = data.msg;
                    if (flag) {
                        self.setp = 3;
                        self.errmsg = "";
                        self.YZM = "";
                    } else {
                        self.errmsg = msg;
                    }
                }).catch(function (error) {
                    self.RefreshYZM();
                    console.log(error);
                });
        },
        Submit() {
            const self = this;
            var params = new URLSearchParams();
            params.append('LOGIN_NAME', self.LOGIN_NAME);
            params.append('CHECK_CODE', self.YZM);
            params.append('ANSWER1', self.ANSWER1);
            params.append('ANSWER2', self.ANSWER2);
            params.append('ANSWER3', self.ANSWER3);
            params.append('NEW_LOGIN_PWD_1', self.NEW_LOGIN_PWD_1);
            axios.post(gConfig.web_pc + '/home/IndexMain/UpdateUserPwdByForget', params).
                then(function (response) {
                    self.RefreshYZM();
                    var data = response.data;
                    var flag = data.flag;
                    var msg = data.msg;
                    if (flag) {
                        alert('修改密码成功，请重新登录');
                        self.errmsg = msg;
                    } else {
                        self.errmsg = msg;
                    }
                }).catch(function (error) {
                    self.RefreshYZM();
                    console.log(error);
                });
        }
    }
}
</script>
<style>
@import '../assets/homeContent/forgetpwd.css';
</style>




// WEBPACK FOOTER //
// src/html/forgetPwd.vue